import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {
  Edit, type EditProps, SimpleForm, Toolbar, useRecordContext,
} from 'react-admin';
import { useRedirect } from 'react-admin';

import IndustryContactSection from './Components/IndustryContactSection';
import IndustryCreditSection from './Components/IndustryCreditSection';
import RecordOutreachButton from './Components/RecordOutreachButton';
import type { IndustryContributor } from '@/Api/studioServerTypes';

function IndustryContributorTitle(): JSX.Element {
  const record = useRecordContext<IndustryContributor>();
  return (
    <Typography variant='h6' component='span'>
      {`Insight - ${record?.Name ?? ''}`.trim() || 'Industry Insight'}
    </Typography>
  );
}

function IndustryContributorHeader(): JSX.Element {
  const record = useRecordContext<IndustryContributor>();
  const redirect = useRedirect();

  return (
    <Box
      mb={2}
      width={{ xs: '100%', md: '90%' }}
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      flexWrap='wrap'
      gap={1}
    >
      <Box
        display='flex' alignItems='center'
        gap={1}
      >
        <Tooltip title='Back to Industry Contributors' arrow>
          <IconButton
            size='small'
            onClick={() => redirect('list', 'industry-contributors')}
            aria-label='Back to Industry Insights'
          >
            <ArrowBackIcon fontSize='small' />
          </IconButton>
        </Tooltip>

        <Typography variant='h5' fontWeight={700}>
          {(record?.Name ?? '').trim() || '—'}
        </Typography>
      </Box>

      <RecordOutreachButton />
    </Box>
  );
}

export default function IndustryInsightsEdit(props: EditProps): JSX.Element {
  return (
    <Edit
      {...props} title={<IndustryContributorTitle />}
      actions={false}
    >
      <SimpleForm toolbar={<Toolbar sx={{ display: 'none' }} />}>
        <IndustryContributorHeader />
        <IndustryContactSection />
        <IndustryCreditSection />
      </SimpleForm>
    </Edit>
  );
}
